export const styles = {
	StackContainer: {
		minHeight: '100%',
		height: '100%',
	},
	CallToActionBox: {
		margin: '1rem',
	},
	ContentBox: {
		flexGrow: 1,
	},
	list: {
		width: '100%',
	},
	LoadingText: {
		my: 4,
		textAlign: 'center',
	},
	LoaderText: {
		textAlign: 'center',
		my: '4rem',
	},
	Divider: {
		color: 'primary.main',
		mx: { lg: 40, md: '3.2rem', sm: '3.2rem', xs: '3.2rem' },
		borderBotttomWidth: 'thick',
	},
}
